import { render } from "./BbPlayerSetup.vue?vue&type=template&id=7c3f008e&scoped=true"
import script from "./BbPlayerSetup.vue?vue&type=script&lang=js"
export * from "./BbPlayerSetup.vue?vue&type=script&lang=js"

import "./BbPlayerSetup.vue?vue&type=style&index=0&id=7c3f008e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c3f008e"]])

export default __exports__